import { Company } from '@components/business/company/Company'
import { CompanyContact } from '@components/business/companyContact/CompanyContact'
import { CompanyStatuses } from '@components/business/companyStatuses/CompanyStatuses'
import Page from '@components/Page/Page'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { Company as CompanyModel } from '@models/business/Company'
import {
  getCompanies,
  selectCompanies,
  setCompanyQuery,
} from '@store/business/CompanyReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import { TableColumnsType } from 'antd'
import { useEffect } from 'react'

const CompaniesPage = () => {
  const { isOpen } = useSBRM()

  const dispatch = useAppDispatch()
  const companies = useAppSelector(selectCompanies())
  const { query, isLoading } = useAppSelector((state) => state.company)

  const columns: TableColumnsType<CompanyModel> = [
    {
      title: 'Name',
      render: (record: CompanyModel) => <Company.Avatar model={record} />,
    },

    {
      title: 'Contacts',
      render: (record: CompanyModel) => {
        return <CompanyContact.GroupAvatar ids={record.contacts} />
      },
    },
    {
      title: '30-day rolling expense',
      render: (record: CompanyModel) => {
        return <Company.RollingDays model={record} />
      },
    },
    {
      title: 'Status',
      render: (record: CompanyModel) => {
        return <CompanyStatuses.StatusTag id={record.status} />
      },
    },
    {
      align: 'right',
      render: (record: CompanyModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update]}
          entity={Entity.company}
          entityId={record.id}
        />
      ),
    },
  ]

  const fetchCompagnies = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setCompanyQuery(newQuery))
    dispatch(getCompanies(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<CompanyModel>({
    onParamsChange: fetchCompagnies,
  })

  useEffect(() => {
    if (isOpen) return

    fetchCompagnies(params)
  }, [isOpen])

  return (
    <Page
      permissions={[Permission.manageBusiness]}
      pageTitle={{
        title: 'Companies',
        level: 4,
        toolbar: (
          <SBRM.Actions actions={[SBRMAction.Create]} entity={Entity.company} />
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={companies}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
      />
    </Page>
  )
}

export default CompaniesPage
